import comp from '../components/barrel';
import listReturnState from '../js/listReturnState';

const GET_EP = 'files/get-email-template-details';
const UPD_EP = 'files/upd-email-template';
const TEST_SEND_EP = 'files/test-send-email-template';

function formatTs(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
}

function formatDefaultSender(d) {
  if (!d) return '—';
  const name = [d.sender_fname, d.sender_sname].filter(Boolean).join(' ').trim();
  const email = d.sender_email != null && String(d.sender_email).trim() !== '' ? String(d.sender_email).trim() : '';
  if (!name && !email) return '—';
  if (name && email) return `${name} (${email})`;
  return name || email;
}

export default {
  async prepare() {
    const uuid = this.vars && this.vars.template_uuid;
    if (uuid) {
      this.recipe.methods.push(await O.mPOST(GET_EP, {template_uuid: uuid}));
    }
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const back = listReturnState.take('Email_template_detail');
    listReturnState.mountBackToListBar('Back to email templates', back);

    const wrap = U.id('emailTemplateDetailFormWrap');
    const sub = U.id('emailTemplateDetailSub');
    const sampleBtn = U.id('emailTemplateSampleBtn');
    if (sampleBtn) {
      sampleBtn.hidden = true;
    }
    if (wrap) {
      wrap.innerHTML = '';
    }

    const uuid = this.vars && this.vars.template_uuid;
    if (!uuid) {
      this.detailData = null;
      if (sub) {
        sub.textContent = 'No template selected. Open a template from the list.';
        sub.hidden = false;
      }
      return;
    }

    const res = data[GET_EP];
    if (!res || res.status !== 'OK' || !res.data) {
      this.detailData = null;
      if (sub) {
        sub.textContent = 'Could not load this template. Try again from the list.';
        sub.hidden = false;
      }
      return;
    }

    this.detailData = res.data;
    if (sub) {
      sub.textContent = '';
      sub.hidden = true;
    }
    if (sampleBtn) {
      sampleBtn.hidden = false;
    }

    const d = this.detailData;
    const form = U.divAtt('form', 'id', 'emailTemplateForm');
    form.setAttribute('novalidate', 'novalidate');
    form.className = 'grid pt-4 gap-4';

    const meta = U.divAtt(
      'div',
      'class',
      'res-grid-cols-2 gap-4 col-span-full border-b border-gray-200 pb-4 mb-2'
    );
    const uuidBlock = U.divAtt('div', 'class', 'input-group col-span-2');
    uuidBlock.innerHTML = '<label>Template UUID</label>';
    const uuidP = document.createElement('p');
    uuidP.className = 'text-sm font-mono break-all';
    uuidP.textContent = d.template_uuid != null ? String(d.template_uuid) : '';
    uuidBlock.appendChild(uuidP);
    meta.appendChild(uuidBlock);

    const roLine = (label, val, multiline) => {
      const p = U.divAtt('div', 'class', 'input-group');
      const lb = document.createElement('label');
      lb.textContent = label;
      const pv = document.createElement('p');
      pv.className = multiline ? 'text-sm whitespace-pre-wrap break-words' : 'text-sm break-words';
      pv.textContent = val != null && val !== '' ? String(val) : '—';
      p.appendChild(lb);
      p.appendChild(pv);
      return p;
    };

    const nameDescMarkersRow = U.divAtt('div', 'class', 'res-grid-cols-3 gap-4 col-span-full');
    nameDescMarkersRow.appendChild(roLine('Template name', d.template_name, false));
    nameDescMarkersRow.appendChild(
      roLine('Description', d.description != null && d.description !== '' ? d.description : null, true)
    );
    const markersDisplay = (() => {
      const dm = d.dynamic_markers;
      if (dm == null) return null;
      if (Array.isArray(dm) && dm.length) {
        return dm
          .map((m) => String(m).trim())
          .filter(Boolean)
          .join(', ');
      }
      if (typeof dm === 'string' && dm.trim() !== '') return dm.trim();
      return null;
    })();
    nameDescMarkersRow.appendChild(roLine('Dynamic markers', markersDisplay, false));
    meta.appendChild(nameDescMarkersRow);

    const createdRow = U.divAtt('div', 'class', 'res-grid-cols-2 gap-4 col-span-full');
    createdRow.appendChild(roLine('Created', formatTs(d.created_date)));
    createdRow.appendChild(
      roLine('Created by', [d.creator_fname, d.creator_sname].filter(Boolean).join(' ') || '—')
    );
    meta.appendChild(createdRow);

    const defaultSenderRow = U.divAtt('div', 'class', 'col-span-full');
    defaultSenderRow.appendChild(roLine('Default sender', formatDefaultSender(d), false));
    meta.appendChild(defaultSenderRow);

    const lastUpdatedRow = U.divAtt('div', 'class', 'res-grid-cols-2 gap-4 col-span-full');
    lastUpdatedRow.appendChild(
      roLine('Last updated by', [d.updator_fname, d.updator_sname].filter(Boolean).join(' ') || '—')
    );
    lastUpdatedRow.appendChild(roLine('Last updated', formatTs(d.updated_date)));
    meta.appendChild(lastUpdatedRow);

    form.appendChild(meta);

    const subjIn = await comp.inputText('subject_template', d.subject_template || '', 'Subject', 1, '', '', false);
    subjIn.classList.add('col-span-full', 'md:col-span-1');
    form.appendChild(subjIn);

    const bodyDiv = U.divAtt('div', 'class', 'input-group col-span-full');
    const bodyLabel = document.createElement('label');
    bodyLabel.setAttribute('for', 'body_template');
    bodyLabel.textContent = 'Body (HTML)';
    const bodyTa = document.createElement('textarea');
    bodyTa.id = 'body_template';
    bodyTa.name = 'body_template';
    bodyTa.setAttribute('val', 'textarea');
    bodyTa.setAttribute('required', '');
    bodyTa.rows = 16;
    bodyTa.className = 'w-full';
    bodyTa.value = d.body_template != null ? d.body_template : '';
    const bodyFb = document.createElement('span');
    bodyFb.setAttribute('fb-for', 'body_template');
    bodyDiv.appendChild(bodyLabel);
    bodyDiv.appendChild(bodyTa);
    bodyDiv.appendChild(bodyFb);
    form.appendChild(bodyDiv);

    const tgl = await comp.toggle('active_yn', !!d.active_yn, 'Active', '');
    tgl.classList.add('col-span-full', 'flex', 'items-center', 'gap-2');
    form.appendChild(tgl);

    const actionRow = U.divAtt('div', 'class', 'mt-6 flex justify-end border-t border-gray-200 pt-4 col-span-full');
    const updateBtn = document.createElement('button');
    updateBtn.type = 'button';
    updateBtn.id = 'emailTemplateUpdateBtn';
    updateBtn.className = 'btn';
    updateBtn.textContent = 'Update';
    updateBtn.setAttribute('onclick', 'thsPage.updateEmailTemplate()');
    actionRow.appendChild(updateBtn);
    form.appendChild(actionRow);

    if (wrap) {
      wrap.appendChild(form);
    }
  },

  async updateEmailTemplate() {
    if (!this.detailData || !this.detailData.template_uuid) {
      comp.toast('No template loaded');
      return;
    }
    if (!(await U.validateForm('emailTemplateForm'))) {
      return;
    }

    const activeEl = U.id('active_yn');
    const vars = {
      template_uuid: this.detailData.template_uuid,
      email_subject: U.id('subject_template').value,
      email_body: U.id('body_template').value,
      active_yn: activeEl ? activeEl.checked : true,
    };

    O.PREP([await O.mPOST(UPD_EP, vars)])
      .then((res) => {
        const msg = res[UPD_EP] && res[UPD_EP].status ? res[UPD_EP].status : 'OK';
        comp.toast(msg);
        return this.render();
      })
      .catch(() => {});
  },

  async sendEmailSampleToMe() {
    if (!this.detailData || !this.detailData.template_uuid) {
      comp.toast('No template loaded');
      return;
    }
    O.PREP([await O.mPOST(TEST_SEND_EP, {template_uuid: this.detailData.template_uuid})])
      .then((res) => {
        const msg = res[TEST_SEND_EP] && res[TEST_SEND_EP].status ? res[TEST_SEND_EP].status : 'OK';
        comp.toast(msg);
      })
      .catch(() => {});
  },
};
